<template>
    <div>
        <div class="demo-spin-article">
            <div class="row mb-3">
                <div class="col-md-4">
                    <label class="form-col-label control-label required">{{
                        $t("motorWithdraw.withdrawDate")
                    }}</label>
                    <DatePicker
                        :value="model.withdraw_date"
                        placeholder="DD-MM-YYYY"
                        format="dd-MM-yyyy"
                        @on-change="onChangewithDrawDate"
                        :options="options"
                        style="width: 100%"
                    ></DatePicker>
                    <div class="text-danger" v-if="errors.has('withdraw_date')">
                        {{ errors.first("withdraw_date") }}
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="form-col-label control-label required">{{
                        $t("motorWithdraw.customer")
                    }}</label>
                    <Select
                        v-model="model.customer_id"
                        filterable
                        clearable
                        :placeholder="$t('motorWithdraw.customer')"
                        :class="{
                            'ivu-form-item-error': errors.has('customer_id')
                        }"
                    >
                        <Option
                            v-for="(option, index) in customers"
                            :value="option.customer_id"
                            :key="index"
                        >
                            {{ option.customer_name_en }} |
                            {{ option.customer_name_kh }}
                        </Option>
                    </Select>
                    <div class="text-danger" v-if="errors.has('customer_id')">
                        {{ errors.first("customer_id") }}
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="form-col-label control-label">{{
                        $t("motorWithdraw.motorType")
                    }}</label>
                    <input
                        v-model.trim="model.motor_type"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('motor_type') }"
                    />
                    <div
                        class="invalid-feedback"
                        v-if="errors.has('motor_type')"
                    >
                        {{ errors.first("motor_type") }}
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-4">
                    <label class="form-col-label control-label required">{{
                        $t("motorWithdraw.obefore")
                    }}</label>
                    <div class="tw-flex tw-space-x-2">
                        <InputNumber
                            v-model="model.outstanding_before"
                            :min="0"
                            style="width: 60%"
                            @on-change="calculateDeductedValue"
                        ></InputNumber>
                        <Select
                            v-model="model.currency_id"
                            style="width: 40%"
                        >
                            <Option
                                v-for="(option, index) in currencies"
                                :value="option.currency_id"
                                :key="index"
                            >
                                {{ option.sign }} {{ option.currency_code }}
                            </Option>
                        </Select>
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="form-col-label control-label required">{{
                        $t("motorWithdraw.oafter")
                    }}</label>
                    <div class="tw-flex tw-space-x-2">
                        <InputNumber
                            v-model="model.outstanding_after"
                            :min="0"
                            style="width: 60%"
                            @on-change="calculateDeductedValue"
                        ></InputNumber>
                        <Select
                            v-model="model.currency_id"
                            style="width: 40%"
                        >
                            <Option
                                v-for="(option, index) in currencies"
                                :value="option.currency_id"
                                :key="index"
                            >
                                {{ option.sign }} {{ option.currency_code }}
                            </Option>
                        </Select>
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="form-col-label control-label required">{{
                        $t("motorWithdraw.deductedValue")
                    }}</label>
                    <div class="tw-flex tw-space-x-2">
                        <InputNumber
                            v-model="model.deducted_value"
                            :min="0"
                            :readonly="true"
                            :disabled="true"
                            style="width: 60%"
                        ></InputNumber>
                        <Select
                            v-model="model.currency_id"
                            :disabled="true"
                            style="width: 40%"
                        >
                            <Option
                                v-for="(option, index) in currencies"
                                :value="option.currency_id"
                                :key="index"
                            >
                                {{ option.sign }} {{ option.currency_code }}
                            </Option>
                        </Select>
                    </div>
                </div>
            </div>
        </div>
        <div class="mb-3">
            <div class="col-md-12">
                <label class="form-col-label control-label required">{{
                    $t("motorWithdraw.reason")
                }}</label>
                <textarea
                    v-model="model.reason"
                    class="form-control"
                    rows="3"
                    :class="{ 'is-invalid': errors.has('reason') }"
                ></textarea>
                <div class="invalid-feedback" v-if="errors.has('reason')">
                    {{ errors.first("reason") }}
                </div>
            </div>
        </div>
        <div class="mb-3">
            <div class="col-md-12">
                <label class="form-col-label control-label required">{{
                    $t("motorWithdraw.remainingDebtSolution")
                }}</label>
                <textarea
                    v-model="model.remaining_debt_solution"
                    class="form-control"
                    rows="3"
                    :class="{
                        'is-invalid': errors.has('remaining_debt_solution')
                    }"
                ></textarea>
                <div
                    class="invalid-feedback"
                    v-if="errors.has('remaining_debt_solution')"
                >
                    {{ errors.first("remaining_debt_solution") }}
                </div>
            </div>
        </div>
        <div slot="footer">
            <div class="tw-flex tw-justify-end tw-space-x-2 tw-sh">
                <ts-button
                    @click.prevent="() => $emit('cancel')"
                    class="btn-gray"
                >
                    {{ $t("cancel") }}</ts-button
                >
                <ts-button
                    color="primary"
                    v-if="!isUpdate"
                    outline
                    :waiting="waiting_new"
                    :disabled="waiting"
                    @click.prevent="onSaveAddNew"
                >
                    {{ $t("saveAddNew") }}</ts-button
                >
                <ts-button
                    color="primary"
                    v-if="!isUpdate"
                    :waiting="waiting"
                    :disabled="waiting_new"
                    @click.prevent="onSave"
                >
                    {{ $t("save") }}</ts-button
                >
                <ts-button
                    v-if="isUpdate"
                    color="primary"
                    @click.prevent="onUpdate"
                    :waiting="waiting"
                >
                    {{ $t("update") }}</ts-button
                >
            </div>
        </div>
        <Spin size="large" fix v-if="loading"> </Spin>
    </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";
import { isEmpty } from "lodash";
import moment from "moment";

export default {
    name: "motorWithdrawForm",
    data() {
        return {
            errors: new Errors(),
            waiting: false,
            waiting_new: false,
            loading: false,
            model: {
                withdraw_date: moment().format("DD-MM-YYYY"),
                customer_id: null,
                motor_type: null,
                currency_id: null,
                deducted_value: null,
                outstanding_before: null,
                outstanding_after: null,
                remaining_debt_solution: null,
                reason: null
            },
            options: {
                disabledDate(date) {
                    return date.valueOf() > Date.now();
                }
            }
        };
    },
    computed: {
        ...mapState("creditOperation/motorWithdraw", [
            "edit_data",
            "customers",
            "currencies"
        ]),
        isUpdate() {
            return !isEmpty(this.edit_data);
        }
    },
    methods: {
        onChangewithDrawDate(date) {
            this.model.withdraw_date = date;
        },
        calculateDeductedValue() {
            const before = Number(this.model.outstanding_before) || 0;
            const after = Number(this.model.outstanding_after) || 0;
            this.model.deducted_value = before - after;
        },
        async fetchResource() {
            this.loading = true;
            await this.$store.dispatch(
                "creditOperation/motorWithdraw/getCustomers"
            );
            await this.$store.dispatch(
                "creditOperation/motorWithdraw/getCurrencies"
            );
            this.setEditData();
            this.loading = false;
        },
        onSaveAddNew() {
            this.errors = new Errors();
            this.waiting_new = true;
            this.$store
                .dispatch("creditOperation/motorWithdraw/store", this.model)
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    this.clearInput();
                    this.$emit("fetchData");
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.waiting_new = false;
                });
        },
        onSave() {
            this.errors = new Errors();
            this.waiting = true;
            this.$store
                .dispatch("creditOperation/motorWithdraw/store", this.model)
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    this.$emit("cancel");
                    this.$emit("fetchData");
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.waiting = false;
                });
        },
        onUpdate() {
            this.errors = new Errors();
            this.waiting = true;
            this.$store
                .dispatch("creditOperation/motorWithdraw/update", {
                    id: this.edit_data.withdraw_id,
                    data: this.model
                })
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    this.$emit("cancel");
                    this.$emit("fetchData");
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.waiting = false;
                });
        },
        setEditData() {
            this.errors = new Errors();
            if (!isEmpty(this.edit_data)) {
                this.model.withdraw_date = this.edit_data.withdraw_date;
                this.model.customer_id = this.edit_data.customer_id;
                this.model.motor_type = this.edit_data.motor_type;
                this.model.currency_id = this.edit_data.currency_id;
                this.model.outstanding_before = this.edit_data.outstanding_before;
                this.model.outstanding_after = this.edit_data.outstanding_after;
                this.calculateDeductedValue();
                this.model.remaining_debt_solution = this.edit_data.remaining_debt_solution;
                this.model.reason = this.edit_data.reason;
            }
        },
        clearInput() {
            this.model.withdraw_date = moment().format("DD-MM-YYYY");
            this.model.customer_id = null;
            this.model.motor_type = null;
            this.model.currency_id = null;
            this.model.deducted_value = null;
            this.model.outstanding_before = null;
            this.model.outstanding_after = null;
            this.model.remaining_debt_solution = null;
            this.model.reason = null;
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "MOTOR WITHDRAW",
                desc: not.text
            });
        }
    }
};
</script>
